module.exports = __webpack_public_path__ + "static/media/qrcode-solid.08566616.svg";